import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import './ApprovalBanner.css';

const ApprovalBanner: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  // Show banner only for unapproved users
  if (!user || user.accountStatus === 'approved') {
    return null;
  }

  return (
    <div className="approval-banner">
      <div className="approval-banner-content">
        <div className="approval-banner-icon">⚠️</div>
        <div className="approval-banner-text">
          <h3>Account Under Review</h3>
          <p>
            Your account is currently under administrative review. Please wait for approval
            to access payment and other restricted features.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ApprovalBanner;
